import type { FolderStatus, FileStatus } from "../../file-tree-manager/types/tree-types"

export const getFolderStatusInfo = (status: FolderStatus) => {
  switch (status) {
    case "draft":
      return { label: "초안", color: "#333", bgColor: "#e0e0e0", isButton: false }
    case "request":
      return { label: "승인 요청", color: "#b26a00", bgColor: "#fff3e0", isButton: true }
    case "pending":
      return { label: "승인 대기", color: "#b26a00", bgColor: "#fff3e0", isButton: false }
    case "approve":
      return { label: "배포 승인", color: "#1b5e20", bgColor: "#e8f5e9", isButton: true }
    case "publishing":
      return { label: "배포 진행중", color: "#1b5e20", bgColor: "#e8f5e9", isButton: true }
    case "published":
      return { label: "배포 완료", color: "#1b5e20", bgColor: "#e8f5e9", isButton: false }
    default:
      return { label: String(status), color: "#333", bgColor: "#e0e0e0", isButton: false }
  }
} 
// export type FolderStatus = "draft" | "requested" | "pending" | "published" | "approve"

export const getFileStatusInfo = (status: FileStatus) => {
  switch (status) {
    case "draft":
      return { label: "초안", color: "#333", bgColor: "#e0e0e0" , isButton: false }
    case "convert":
      return { label: "변환 요청", color: "#0d47a1", bgColor: "#e3f2fd" , isButton: true }
    case "converting":
      return { label: "변환 중", color: "#1a237e", bgColor: "#e8eaf6" , isButton: false }
    case "converted":
      return { label: "MarkDown 변환", color: "#1a237e", bgColor: "#e8eaf6" , isButton: false }
    case "review":
      return { label: "담당자 리뷰", color: "#b26a00", bgColor: "#fff3e0" , isButton: false }
    case "request":
      return { label: "배포 요청", color: "#b26a00", bgColor: "#fff3e0" , isButton: true }
    case "requested":
      return { label: "배포 승인 대기", color: "#b26a00", bgColor: "#fff3e0" , isButton: false }
    case "approve":
      return { label: "배포 승인", color: "#b26a00", bgColor: "#fff3e0" , isButton: true }
    case "publishing":
      return { label: "배포 진행중", color: "#b26a00", bgColor: "#fff3e0" , isButton: false }
    case "published":
      return { label: "배포 완료", color: "#1b5e20", bgColor: "#e8f5e9" , isButton: false }
    default:
      return { label: String(status), color: "#333", bgColor: "#e0e0e0" , isButton: false }
  }
}

export const getStatusIcon = (iconName: string) => {
  return null
}

export const getFolderStatusOptions = (): { value: FolderStatus; label: string, isButton: boolean }[] => [
  { value: "draft", label: "초안", isButton: false },
  { value: "request", label: "승인 요청", isButton: true },
  { value: "pending", label: "승인 대기", isButton: false },
  { value: "approve", label: "배포 승인", isButton: true },
  { value: "publishing", label: "배포 진행중", isButton: true },
  { value: "published", label: "배포 완료", isButton: false },
]

export const getFileStatusOptions = (): { value: FileStatus; label: string, isButton: boolean }[] => [
  { value: "draft", label: "초안", isButton: false },
  { value: "convert", label: "변환 요청", isButton: true },
  { value: "converting", label: "변환 중", isButton: false },
  { value: "review", label: "담당자 리뷰", isButton: false },
  { value: "request", label: "배포 요청", isButton: true },
  { value: "requested", label: "배포 승인 대기", isButton: false },
  { value: "approve", label: "배포 승인", isButton: true },
  { value: "publishing", label: "배포 진행중", isButton: false },
  { value: "published", label: "배포 완료", isButton: false },
]